import * as XLSX from 'xlsx';
import { Package } from '../types/package';

export const exportPackagesToExcel = (packages: Package[]): boolean => {
  try {
    if (packages.length === 0) {
      console.warn('No packages to export');
      return false;
    }
    
    // Prepare data for export
    const data = packages.map(pkg => ({
      'Package Name': pkg.name,
      
      // Main Makkah Hotel
      'Main Makkah Hotel': pkg.mainMakkahHotel,
      'Main Makkah Start Date': pkg.mainMakkahStartDate,
      'Main Makkah End Date': pkg.mainMakkahEndDate,
      'Main Makkah Contract ID': pkg.mainMakkahContractId || '',
      'Main Makkah Contract Start': pkg.mainMakkahContractStartDate || '',
      'Main Makkah Contract End': pkg.mainMakkahContractEndDate || '',
      
      // Shifting Makkah Hotel
      'Shifting Makkah Hotel': pkg.shiftingMakkahHotel || '',
      'Shifting Makkah Start Date': pkg.shiftingMakkahStartDate || '',
      'Shifting Makkah End Date': pkg.shiftingMakkahEndDate || '',
      'Shifting Makkah Contract ID': pkg.shiftingMakkahContractId || '',
      'Shifting Makkah Contract Start': pkg.shiftingMakkahContractStartDate || '',
      'Shifting Makkah Contract End': pkg.shiftingMakkahContractEndDate || '',
      
      // Madinah Hotel
      'Madinah Hotel': pkg.madinahHotel,
      'Madinah Start Date': pkg.madinahStartDate,
      'Madinah End Date': pkg.madinahEndDate,
      'Madinah Contract ID': pkg.madinahContractId || '',
      'Madinah Contract Start': pkg.madinahContractStartDate || '',
      'Madinah Contract End': pkg.madinahContractEndDate || '',
      
      // Package Details
      'Package Type': pkg.packageType,
      'Camp': pkg.camp
    }));
    
    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(data);
    
    // Set column widths
    ws['!cols'] = [
      { wch: 20 }, // Package Name
      
      // Main Makkah
      { wch: 25 }, // Main Makkah Hotel
      { wch: 15 }, // Main Makkah Start Date
      { wch: 15 }, // Main Makkah End Date
      { wch: 20 }, // Main Makkah Contract ID
      { wch: 15 }, // Main Makkah Contract Start
      { wch: 15 }, // Main Makkah Contract End
      
      // Shifting Makkah
      { wch: 25 }, // Shifting Makkah Hotel
      { wch: 15 }, // Shifting Makkah Start Date
      { wch: 15 }, // Shifting Makkah End Date
      { wch: 20 }, // Shifting Makkah Contract ID
      { wch: 15 }, // Shifting Makkah Contract Start
      { wch: 15 }, // Shifting Makkah Contract End
      
      // Madinah
      { wch: 25 }, // Madinah Hotel
      { wch: 15 }, // Madinah Start Date
      { wch: 15 }, // Madinah End Date
      { wch: 20 }, // Madinah Contract ID
      { wch: 15 }, // Madinah Contract Start
      { wch: 15 }, // Madinah Contract End
      
      // Package Details
      { wch: 15 }, // Package Type
      { wch: 20 }, // Camp
    ];
    
    // Create workbook and add worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Packages');
    
    // Generate filename with date
    const date = new Date().toISOString().split('T')[0];
    const filename = `hajj-packages-${date}.xlsx`;
    
    // Export to file
    XLSX.writeFile(wb, filename);
    return true;
  } catch (error) {
    console.error('Error exporting packages:', error);
    return false;
  }
};